/** * * Asynchronously loads the component for
Return Policy
* */ import { lazyLoad } from "utils/loadable";
export const ReturnPolicy = lazyLoad(
  () => import("./index"),
  (module) => module.ReturnPolicy
);
